import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { createExportTaskFailed, createExportTaskSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { CREATED } from '../../../configs/serverStatusCodes';
import { BACKEND_URL_V2 } from '../../../configs';
import { addFilterQuery } from '../../../utils/addFilterQueryWithCondition';

export default function* createExportTask(action) {
  try {
    const url = `${BACKEND_URL_V2}/export-tasks`;
    const pool = action.payload;
    pool.filters = addFilterQuery(action?.payload?.filters || {});
    const response = yield makeRequest(url, action.payload, action, 'POST', true);
    const data = yield getBodyJson(response);
    if (response.status === CREATED && data.data) {
      yield put(createExportTaskSuccessful());
      yield call(resolveActionPromise(action, data.data));
    } else {
      yield put(createExportTaskFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(createExportTaskFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
